import { TAppTag } from 'js/components/system/TagManager/types';

import * as Types from './types';
import { actionTypes } from './constants';

export const fetchApp = ({ app }: { app: Partial<Types.TRawAppData> }): Types.IFetchAppAction => ({
    type: actionTypes.APP_FETCH,
    payload: { app }
});

export const toggleIsAppInitExecuted = (isAppInitExecuted: boolean): Types.IToggleIsAppInitExecutedAction => ({
    type: actionTypes.TOGGLE_IS_APP_INIT_EXECUTED,
    payload: isAppInitExecuted
});

export const updateHeaderHeight = ({ height, decrement }: {
    height: number,
    decrement?: number
}): Types.IUpdateHeaderHeightAction => ({
    type: actionTypes.UPDATE_HEADER_HEIGHT,
    payload: { height, decrement }
});

export const setIsQuickDepositAvailable = ({ isQuickDepositAvailable }: {
    isQuickDepositAvailable: boolean
}): Types.ISetIsQuickDepositAvailableAction => ({
    type: actionTypes.SET_IS_QUICK_DEPOSIT_AVAILABLE,
    payload: { isQuickDepositAvailable }
});

export const addTags = (tags: TAppTag[]): Types.IAddTagsAction => ({
    type: actionTypes.ADD_TAGS,
    payload: tags
});

export const toggleReconnectVisible = (isReconnectVisible: boolean): Types.IToggleReconnectVisibleAction => ({
    type: actionTypes.TOGGLE_RECONNECT,
    payload: isReconnectVisible
});

export const updateMenuItems = (menuItems: Types.IMenuItemConfig[]): Types.IUpdateMenuItemsAction => ({
    type: actionTypes.UPDATE_MENU_ITEMS,
    payload: menuItems
});

export const updateGamesData = (gamesData: Types.IGamesData): Types.IUpdateGamesDataAction => ({
    type: actionTypes.UPDATE_GAMES_DATA,
    payload: gamesData
});

export const setConfigurationAction = (rgConfig: Types.IResponsibleGamingConfig): Types.IResponsibleGamingConfigAction => ({
    type: actionTypes.SET_RG_CONFIG,
    payload: { rgConfig }
});

export const setFavoriteGamesAction = (
    { favoriteGames, isFavoritesFetching }: { favoriteGames: string[], isFavoritesFetching: boolean }
): Types.ISetFavoriteGamesAction => ({
    type: actionTypes.SET_FAVORITE_GAMES,
    payload: { favoriteGames, isFavoritesFetching }
});

export const updateFavoriteGamesAction = (
    { code, isFavorite }: { code: string, isFavorite: boolean }
): Types.IUpdateFavoriteGamesAction => ({
    type: actionTypes.UPDATE_FAVORITE_GAMES,
    payload: { code, isFavorite }
});
